import { get } from 'svelte/store';
import { filterStores } from '../../state';
import type { FilterDrawerCollection, FilterDrawerState, FilterSections } from '../../types';
import {
	ARTIST_FILTER_TYPES,
	resolveFilterFacets
} from '../getFilterTrackEvents/getFilterTrackEvents';
import { isEmptyValue } from '../getFilterValueLabel/getFilterValueLabel';

// The artist(s) currently narrowing the grid, resolved from the applied filter
// state. HB-975 wants `artist` as a cross-cutting dimension on every grid
// interaction, not just the moment the artist facet is applied — so sort,
// load-more and clear events read it back out of the filter state here.
export const getActiveArtist = ({
	filter,
	filterSections
}: {
	filter: FilterDrawerState;
	filterSections: FilterSections;
}): string | undefined => {
	const collections = Object.values(filter || {}).filter(
		(collection): collection is FilterDrawerCollection =>
			!!collection && !isEmptyValue(collection.value)
	);

	return (
		resolveFilterFacets({ collections, filterSections }).find(({ filterType }) =>
			ARTIST_FILTER_TYPES.includes(filterType)
		)?.filterValue || undefined
	);
};

// Store-backed convenience wrapper for callers that fire outside the filter
// drawer (sort changes, chip removal, load more) and have no filter state to hand.
export const getActiveArtistFromStores = (): string | undefined =>
	getActiveArtist({
		filter: get(filterStores.filterStore),
		filterSections: get(filterStores.filterSectionsStore)
	});
